import React from 'react';

import { BlockContainer, Layout, Column } from '../../Layout';

import {
  Cell,
  Row,
  Table,
  TableHeader
} from './CaliforniaResidentsTable.styles';

import { TableHeaders, TableData } from './CaliforniaResidentsTableData';

export function CaliforniaResidentsTable() {
  return (
    <BlockContainer
      marginBottom={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
      marginTop={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
      data-blockid="californiaTable"
      data-testid="california-residents-table"
    >
      <Layout>
        <Column size={{ 0: 10, tablet: 8 }} flexDirection="column">
          <Table>
            <thead>
              <tr>
                <TableHeader>{TableHeaders.column1}</TableHeader>
                <TableHeader>
                  {TableHeaders.column2}
                  <br />
                  (not all items are collected for each consumer)
                </TableHeader>
                <TableHeader>{TableHeaders.column3}</TableHeader>
              </tr>
            </thead>
            <tbody>
              {TableData.map((row, index) => (
                <Row key={index}>
                  <Cell>{row.column1}</Cell>
                  <Cell>{row.column2}</Cell>
                  <Cell>{row.column3}</Cell>
                </Row>
              ))}
            </tbody>
          </Table>
        </Column>
      </Layout>
    </BlockContainer>
  );
}
